import cn from 'client/utils/cn';
import React, { Component } from 'react';

import './index.css';

const b = cn('icon-expand');

interface Props {
    opened: boolean;
}
class IconExpand extends Component<Props> {

    render() {
        return (
            <div role={'button'} className={b({ opened: this.props.opened })} />
        );
    }
}

export default IconExpand;
